export const truncate = (htmlCaption, words) => {
  const stringCaption = htmlCaption.replace(/(<([^>]+)>)/gi, '');
  return stringCaption.split(' ').splice(0, words).join(' ');
};
